import { COLOR_GREY_600 } from 'src/constants/styleOptions';

const tableCellPadding = {
  paddingTop: 6,
  paddingRight: 16,
  paddingBottom: 6,
  paddingLeft: 16,
};

const resultsTableStyle = {
  root: {
    '& .ps__rail-x': {
      opacity: '0.25'
    },
    '& .ps__rail-y': {
      opacity: '0.25'
    },
  },
  table: {
    '& .MuiTableCell-sizeSmall': {
      ...tableCellPadding,
    },
  },
  tableHead: {
    '& th': {
      height: 50,
    }
  },
  tableRow: {
    height: 20,
    verticalAlign: 'top',
    '& td.MuiTableCell-paddingCheckbox': {
      ...tableCellPadding,
      paddingTop: 3,
    },
    '&.isSending td': {
      color: COLOR_GREY_600,
    },
    '&.little-hidden-1': {
      backgroundColor: 'rgba(204,204,204,0.45) !important',
      '& *:not(.not-hidden):not(.not-hidden *)': {
        color: `${COLOR_GREY_600} !important`,
      },
      '& img:not(.not-hidden-img):not(.not-hidden-img img)': {
        opacity: '0.5',
      },
    },
  },
  actions: {
    minWidth: 125
  },
  rows: {
    height: 10
  },
};

export default resultsTableStyle;
